// src/components/landing/CTASection.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Transform Your Note-Taking?
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-3xl mx-auto">
            Join thousands of students and professionals who are already using IntelliNote AI to work smarter, not harder.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link
              to="/signup"
              className="inline-flex items-center justify-center px-10 py-5 text-lg font-bold bg-white text-blue-600 rounded-xl hover:bg-gray-100 transition-all transform hover:scale-105 shadow-2xl hover:shadow-3xl"
            >
              Start Your Free Trial
              <svg className="ml-3 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </Link>
            <Link
              to="/demo"
              className="inline-flex items-center justify-center px-10 py-5 text-lg font-bold bg-transparent border-2 border-white text-white rounded-xl hover:bg-white/10 transition-all transform hover:scale-105"
            >
              Schedule a Demo
              <svg className="ml-3 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </Link>
          </div>
          
          {/* Trust Indicators */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-2xl font-bold text-white mb-2">✅</div>
              <div className="text-white/90">No credit card required</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white mb-2">🚀</div>
              <div className="text-white/90">Set up in 2 minutes</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white mb-2">👥</div>
              <div className="text-white/90">Team collaboration</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white mb-2">📱</div>
              <div className="text-white/90">Works on all devices</div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 right-0 h-20 bg-gradient-to-b from-white/10 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white/10 to-transparent" />
    </section>
  );
};

export default CTASection;